import Head from 'next/head';
import { ReactElement } from 'react';

import { getLayout } from 'components/layouts/Sidebar';
import { withAuth } from 'lib/hocs/withAuth';
import SocietyNewslettersListing from './SocietyNewslettersListing';

const Newsletters = (): ReactElement => {
  return (
    <>
      <Head>
        <title>Newsletters - Huzzle</title>
        <meta name="description" content="Huzzle" />
      </Head>
      <SocietyNewslettersListing />
    </>
  );
};

const NewslettersWrapper = withAuth(Newsletters);

// @ts-ignore
NewslettersWrapper.getLayout = getLayout;

export default NewslettersWrapper;
